import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31a33554"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "login-bg" }
const _hoisted_3 = { class: "login-box" }
const _hoisted_4 = { class: "logo" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]

import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import type { FormInstance } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import iconUser from '@/assets/icons/icon-login-user.png'
import iconLock from '@/assets/icons/icon-lock.png'
import { oauthToken, sendVerificationcode } from '@/api'
import { encode } from '@/utils'
import LanSwitch from '@/components/lan-switch'
import i18n from '@/i18n'
import { useAuthStore } from '@/stores/auth'
import iconCode from '@/assets/icons/icon-login-code.png'
import { COUNT_NUMBER } from '@/common'
import sha384 from 'crypto-js/sha384'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const authStore = useAuthStore()
const t = i18n.global.t

const router = useRouter()
const $route = useRoute()

//
const redirect: any = $route.query.redirect

const formRef: any = ref<FormInstance>()

const formData = ref({
  username: '',
  password: '',
  verfycode: '',
})

const rules = {
  username: [{ required: true, message: t('LOGIN.usernamePla') }],
  password: [{ required: true, message: t('LOGIN.passwordPla') }],
  verfycode: [{ required: true, message: '请输入验证码' }],
}

const enMobileCode = () => {
  const { verfycode } = formData.value
  return sha384(verfycode + 'webApp').toString()
}

const errorMessage = ref('')
const loading = ref(false)
const onSubmit = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      const { username, password } = formData.value
      loading.value = true
      errorMessage.value = ''

      const res: any = await oauthToken({
        grant_type: 'mobile_password_verfycode',
        client_id: 'webApp',
        client_secret: 'webApp',
        username,
        password: encode(password),
        verfycode: enMobileCode(),
      }).finally(() => {
        loading.value = false
      })

      if (res?.code === '400') {
        errorMessage.value = res?.msg || t('LOGIN.loginMsg')
      } else if (res?.access_token) {
        ElMessage({
          message: t('LOGIN.loginSuccess'),
          type: 'success',
        })
        localStorage.setItem('Authorization', res.access_token)
        localStorage.setItem('AuthorizationUser', username)

        authStore.clearAuth()

        if (redirect) {
          location.href = redirect
          return
        }
        router.push('/')
      }
    }
  })
}

const toResetPassword = () => {
  router.push('/forget-password')
}

const keydown = (event: any) => {
  if (event?.key === 'Enter') {
    onSubmit()
  }
}

const sendCode = async () => {
  const { username } = formData.value
  const res: any = await sendVerificationcode({
    username,
    appCode: 'webApp',
  })
  if (res?.code === 0) {
    ElMessage({
      message: res?.msg,
      type: 'success',
    })
  }
}

// 倒计时
const number = ref(0)
const timer: any = ref(0)
const start = ref(false)
const countDown = () => {
  if (!formData.value.username) {
    ElMessage({
      message: '请先输入用户名',
      type: 'error',
    })
    return
  }
  sendCode()
  number.value = COUNT_NUMBER
  start.value = true
  clearInterval(timer.value)
  timer.value = setInterval(() => {
    if (number.value === 0) {
      clearInterval(timer.value)
      start.value = false
      return
    }
    number.value = number.value - 1
  }, 1000)
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(LanSwitch), {
      effect: "dark",
      class: "lan-switch"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('COMMON.platformName')), 1),
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          class: "form",
          model: formData.value,
          rules: rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { prop: "username" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.username) = $event)),
                  modelModifiers: { trim: true },
                  size: "large",
                  placeholder: _ctx.$t('LOGIN.usernamePla'),
                  maxlength: "50",
                  name: "username"
                }, {
                  prefix: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _unref(iconUser),
                      alt: ""
                    }, null, 8, _hoisted_5)
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "verfycode" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.verfycode,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.verfycode) = $event)),
                  modelModifiers: { trim: true },
                  size: "large",
                  placeholder: "请输入验证码",
                  maxlength: "10"
                }, {
                  prefix: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _unref(iconCode),
                      alt: ""
                    }, null, 8, _hoisted_6)
                  ]),
                  suffix: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      disabled: start.value || !formData.value.username,
                      type: "info",
                      onClick: countDown,
                      class: _normalizeClass(["code", start.value ? 'code-disabled' : '']),
                      link: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(start.value ? '重新获取' + number.value + 's' : '获取验证码'), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "class"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "password",
              error: errorMessage.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "password",
                  modelValue: formData.value.password,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.password) = $event)),
                  modelModifiers: { trim: true },
                  size: "large",
                  placeholder: _ctx.$t('LOGIN.passwordPla'),
                  maxlength: "50",
                  onKeydown: keydown,
                  "show-password": ""
                }, {
                  prefix: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _unref(iconLock),
                      alt: ""
                    }, null, 8, _hoisted_7)
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["error"]),
            _createElementVNode("p", null, [
              _createElementVNode("a", { onClick: toResetPassword }, _toDisplayString(_ctx.$t('LOGIN.forgetPwd')), 1)
            ]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  loading: loading.value,
                  type: "primary",
                  onClick: onSubmit,
                  class: "btn",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('LOGIN.btnLogin')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
}
}

})